import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "8"
}), 'FiberManualRecordRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FiberManualRecordRounded.js
// module id = 3551
// module chunks = 2